import { Box } from '@mui/material';
import { HeaderNavbar } from 'modules';
import { Outlet } from 'react-router-dom';



export type LayoutProps = {};

export const FC = (props: LayoutProps) => {
  return (
    <Box sx={{
      paddingX: '1.5rem'
    }}
    >
      <HeaderNavbar.FC />

      <Outlet />
    </Box>
  );
};
